import { useI18n } from "@/i18n/I18nContext";
import { PLANS, useMoney } from "@/components/subscriptions/SubscriberCard";

const Tile = ({ label, value, testId, accent = false }) => (
  <div className={`card-carbon min-w-0 rounded-2xl p-4 ${accent ? "border-[var(--gold)]" : ""}`} data-testid={testId}>
    <p className="break-words text-xs font-semibold uppercase tracking-wider text-neutral-400">{label}</p>
    <p className={`mt-1 break-words font-display text-2xl font-bold ${accent ? "gold-text" : "text-white"}`} data-testid={`${testId}-value`}>{value}</p>
  </div>
);

export const SubsSummary = ({ d }) => {
  const { t, fmtNum } = useI18n();
  const c = d.counts;
  return (
    <section className="grid min-w-0 gap-4" data-testid="subs-summary">
      <div className="grid min-w-0 grid-cols-2 gap-3 lg:grid-cols-5">
        <div className="col-span-2 lg:col-span-1"><Tile label={t("subs.paidTotal")} value={fmtNum(c.paid_total)} testId="subs-paid-total" accent /></div>
        {PLANS.map((p) => (
          <Tile key={p} label={p === "custom" ? t("subs.custom") : p[0].toUpperCase() + p.slice(1)} value={fmtNum(c.by_plan[p])} testId={`subs-plan-${p}`} />
        ))}
      </div>
      <div className="grid min-w-0 grid-cols-2 gap-3 lg:grid-cols-4">
        {[["vip", "subs.vip"], ["late", "subs.late"], ["cancelling", "subs.cancelling"], ["suspended", "subs.suspended"]].map(([k, l]) => (
          <Tile key={k} label={t(l)} value={fmtNum(c[k])} testId={`subs-count-${k}`} />
        ))}
      </div>
    </section>
  );
};

export const MrrCard = ({ mrr }) => {
  const { t, fmtNum } = useI18n();
  const money = useMoney();
  return (
    <section className="card-carbon min-w-0 rounded-2xl p-5" data-testid="subs-mrr">
      <h2 className="break-words font-display text-base uppercase tracking-wider text-[var(--gold-bright)] md:text-lg">{t("subs.mrr")}</h2>
      <div className="mt-4 grid min-w-0 gap-4 sm:grid-cols-2">
        {["eur", "usd"].map((cur) => (
          <div key={cur} className="min-w-0 rounded-xl border border-neutral-700 p-4" data-testid={`subs-mrr-${cur}`}>
            <p className="text-xs font-semibold uppercase tracking-wider text-neutral-400">{cur.toUpperCase()} · {t("subs.subsCount", { n: fmtNum(mrr[cur].count) })}</p>
            <p className="mt-2 break-words font-display text-2xl font-bold text-white" data-testid={`subs-mrr-${cur}-ht`}>{money(mrr[cur].ht, cur)} <span className="text-sm text-neutral-400">{t("subs.ht")}</span></p>
            <p className="mt-1 break-words text-sm text-neutral-200" data-testid={`subs-mrr-${cur}-ttc`}>{money(mrr[cur].ttc, cur)} {t("subs.ttc")}</p>
            <p className="mt-1 break-words text-sm font-semibold text-emerald-200" data-testid={`subs-mrr-${cur}-net`}>{money(mrr[cur].net_est, cur)} · {t("subs.netEst")}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-neutral-400">{t("subs.vatNote")}</p>
    </section>
  );
};
